<template>
  <div class="space-y-3">
    <UFormField
      v-for="question in questions"
      :key="question.id"
      :label="question.question"
    >
      <UInput
        v-if="question.type === 'text' || question.type === 'number' || question.type === 'slider'"
        :model-value="String(model[question.id] ?? '')"
        :type="question.type === 'number' || question.type === 'slider' ? 'number' : 'text'"
        :min="question.min"
        :max="question.max"
        :inputmode="question.type === 'number' || question.type === 'slider' ? 'decimal' : 'text'"
        @update:model-value="set(question.id, question.type === 'text' ? $event : $event === '' ? '' : Number($event))"
      />
      <UTextarea
        v-else-if="question.type === 'textarea'"
        :model-value="String(model[question.id] ?? '')"
        :rows="3"
        @update:model-value="set(question.id, $event)"
      />
      <URadioGroup
        v-else-if="question.type === 'radio'"
        :model-value="String(model[question.id] ?? '')"
        :items="(question.options ?? []).map((item) => ({ value: item.value, label: item.label }))"
        value-key="value"
        label-key="label"
        @update:model-value="set(question.id, $event)"
      />
      <div
        v-else
        class="space-y-2"
      >
        <label
          v-for="option in question.options ?? []"
          :key="option.value"
          class="flex min-h-11 cursor-pointer items-center gap-3 text-sm"
        >
          <input
            type="checkbox"
            :checked="selected(question.id).includes(option.value)"
            @change="toggle(question.id, option.value)"
          >
          <span>{{ option.label }}</span>
        </label>
      </div>
    </UFormField>
  </div>
</template>

<script setup lang="ts">
import type { LeadQuestion } from '~/utils/leads/questions'

const model = defineModel<Record<string, unknown>>({ default: () => ({}) })
defineProps<{ questions: LeadQuestion[] }>()

function set(id: string, value: unknown) {
  model.value = { ...model.value, [id]: value }
}

function selected(id: string): string[] {
  const raw = model.value[id]
  return Array.isArray(raw) ? raw.map(String) : []
}

function toggle(id: string, value: string) {
  const next = new Set(selected(id))
  if (next.has(value)) next.delete(value)
  else next.add(value)
  set(id, [...next])
}
</script>
